import type { User } from '../types';

export function canManageWarehouse(user: Pick<User, 'role'> | null | undefined): boolean {
  return user?.role === 'admin' || user?.role === 'manager';
}
